<template>
  <div>
    <form id="formSiteSetupAdvanced" @change="clearErrors()" class="d-flex flex-column" v-on:submit.prevent="updateAdvancedSiteSettings">
      <div class="d-flex flex-column tab-card-form">
        <div class="element-info">
          <div class="row align-items-center">
            <div v-if="this.mobile" class="col-sm-8">
              <div class="element-info-with-icon justify-content-center">
                <div class="element-info-text text-center">
                  <h5 class="element-inner-header">Advanced</h5>
                  <div class="element-inner-desc">Here you can change the advanced site settings.</div>
                </div>
              </div>
            </div>
            <div v-else class="col-sm-8">
              <div class="element-info-with-icon">
                <div class="element-info-icon">
                  <fontAwesomeIcon :icon="['fas', 'atom']" size="2x" />
                </div>
                <div class="element-info-text ml-5">
                  <h5 class="element-inner-header">Advanced</h5>
                  <div class="element-inner-desc">Here you can change the advanced site settings.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-box d-flex flex-column">
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Base URL</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field">{{ setupAdvanced.base_href }}</span>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <div v-if="this.mobile" slot="description">
                <p>(percent % can be used as a wildcard)</p>
              </div>
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">URL pattern</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <span class="form-control disabled-field">{{ setupAdvanced.pattern }}</span>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Match pattern with</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-select v-model="setupAdvanced.pattern_matches" class="text-capitalize" required>
                  <option value="path">Path</option>
                  <option value="host">Hostname</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Enable batch filter</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-select v-model="setupAdvanced.enable_batch_filter" class="text-capitalize">
                  <option value="off">Off</option>
                  <option value="full_archive">Full Archive</option>
                  <option value="last_month">Last Month</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.show_details_form"
                  name="show_details_form"
                  :value="1"
                  :unchecked-value="0">
                  Show additional details on Email Update at Login
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.proof_totals_req"
                  name="proof_totals_req"
                  :value="1"
                  :unchecked-value="0">
                  Insert batch total value into Proof Report
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.delivery_reports"
                  name="delivery_reports"
                  :value="1"
                  :unchecked-value="0">
                  Show Link to Delivery Reports
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.user_delete_button"
                  name="user_delete_button"
                  :value="1"
                  :unchecked-value="0">
                  Show "Delete" button in Document Tools
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.user_reply_button"
                  name="user_reply_button"
                  :value="1"
                  :unchecked-value="0">
                  Show "Reply" button in Document Viewing Window
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.documents_display_currency"
                  name="documents_display_currency"
                  :value="1"
                  :unchecked-value="0">
                  Display Currency Column in the Document View
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.postcode_sorting"
                  name="postcode_sorting"
                  :value="1"
                  :unchecked-value="0">
                  Order documents for postroom by postcode
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.residue_markers"
                  name="residue_markers"
                  :value="1"
                  :unchecked-value="0">
                  Insert residue markers
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.format_values"
                  name="format_values"
                  :value="1"
                  :unchecked-value="0">
                  Format values by thousands
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.send_exceptions_enabled"
                  name="send_exceptions_enabled"
                  :value="1"
                  :unchecked-value="0">
                  Enable Send Exceptions
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.enable_contact_dropdown"
                  name="enable_contact_dropdown"
                  :value="1"
                  :unchecked-value="0">
                  Enable contact dropdown on documents page
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.send_consolidation_emails"
                  name="send_consolidation_emails"
                  :value="1"
                  :unchecked-value="0">
                  Send consolidation emails
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.force_periodic_password_change"
                  name="force_periodic_password_change"
                  :value="1"
                  :unchecked-value="0">
                  Force password change options
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.principal_management"
                  name="principal_management"
                  :value="1"
                  :unchecked-value="0">
                  Enable Principal Management
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.multiple_document_search"
                  name="multiple_document_search"
                  :value="1"
                  :unchecked-value="0">
                  Enable Multiple Document Search
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.batch_filter"
                  name="batch_filter"
                  :value="1"
                  :unchecked-value="0">
                  Filter Batch by approved, unapproved & rejected
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.zip_download"
                  name="zip_download"
                  :value="1"
                  :unchecked-value="0">
                  Download documents in a ZIP file
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.batch_insert"
                  name="batch_insert"
                  :value="1"
                  :unchecked-value="0">
                  Display the batch insert button
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.splitter_management"
                  name="splitter_management"
                  :value="1"
                  :unchecked-value="0">
                  Enable Splitter Management Module
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.show_activity_dashboard"
                  name="show_activity_dashboard"
                  :value="1"
                  :unchecked-value="0">
                  Show Dashboard
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.document_progress_report"
                  name="document_progress_report"
                  :value="1"
                  :unchecked-value="0">
                  Enable Document Progress Report
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.hash_logon"
                  name="hash_logon"
                  :value="1"
                  :unchecked-value="0">
                  Enable Hash Logon
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.enable_document_download_info"
                  name="enable_document_download_info"
                  :value="1"
                  :unchecked-value="0">
                  Enable Document Download Info
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Email Encoding</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-select v-model="setupAdvanced.email_format">
                  <option value="text/plain">text/plain</option>
                  <option value="text/html">text/html</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Hash Expiry Time (Hours)</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input v-model="setupAdvanced.hash_expiry_time_hours"></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group class="px-2">
                <p v-if="this.mobile" class="row justify-content-center text-center">
                  User level:
                 <b-form-input class="col-lg-2 col-sm-6 mx-2" v-model="setupAdvanced.password_change_level"></b-form-input>
                  (users with level >= this value will be impacted)
                </p>
                <p v-else class="row align-items-center mt-1">
                  User level:
                 <b-form-input class="col-1 mx-2" v-model="setupAdvanced.password_change_level"></b-form-input>
                  (users with level >= this value will be impacted)
                </p>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.enable_freetext_invoices"
                  name="enable_freetext_invoices"
                  :value="1"
                  :unchecked-value="0">
                  Enable freetext invoicing for Moreton Smith Copy Invoicing
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.enable_send_method_report"
                  name="enable_send_method_report"
                  :value="1"
                  :unchecked-value="0">
                  Enable send method report
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12 align-self-start">
              <b-input-group>
                <b-form-checkbox
                  v-model="setupAdvanced.enable_protected_user"
                  name="enable_protected_user"
                  :value="1"
                  :unchecked-value="0">
                  Enable protected user
                </b-form-checkbox>
              </b-input-group>
            </b-form-group>
          </div>
         <div class="row">
            <b-form-group class="mt-3 col-lg-6 col-sm-12">
              <b-input-group>
                <b-input-group-prepend class="col-lg-5 col-sm-6 p-0">
                   <b-input-group-text slot="prepend" class="col-12 pretext">
                     <span class="pretext-span">Enable Multiple Customer Search</span>
                   </b-input-group-text>
                </b-input-group-prepend>
                <b-form-select v-model="setupAdvanced.multiple_customer_search">
                  <option value="none">Off</option>
                  <option v-for="level in getUserDetails.userLevels" :key="level.level" v-bind:value="level.level">{{level.name}}</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </div>
          <transition name="fade">
            <ResponseInfo v-if="getResponseInfo.name == 'siteSetupAdvanced'" class="mt-3"/>
          </transition>
          <button v-if="!this.mobile" class="btn btn-primary mt-3 align-self-end" type="submit" value="submit">Update</button>
          <button v-else class="btn btn-secondary mt-3 align-self-end" type="submit" value="submit">Update</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import ValidationErrors from '@/components/ValidationErrors.vue'

export default{
  name: 'SiteSetupAdvanced',
  components: {
      ResponseInfo,
      ValidationErrors
  },
  data() {
    return {
      setupAdvanced: {},
      mobile: window.innerWidth <= 700
    }
  },
  created() {
    advancedSiteSettings:{
        this.$store.dispatch('getAdvancedSiteSettings')
        .then(() => {
            if(Object.keys(this.advancedSiteSettings).length){
                this.setupAdvanced = Object.assign({}, this.advancedSiteSettings)
            }
        })
    }
    window.addEventListener('resize', () => {
          this.mobile = window.innerWidth <= 700
    })
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getAdvancedSiteSettings', 'getResponseInfo']),
      advancedSiteSettings:{
          get() {
              return this.$store.getters.getAdvancedSiteSettings
          }
      }
  },
  methods: {
    clearErrors() {
      //clearing the error message when we change the input
      this.$store.commit('setValidationErrors', [])
    },
    updateAdvancedSiteSettings(){
      var updateableSettings = Object.assign({}, this.setupAdvanced)
      // here we copy the input field's values
      // and delete the "Base URL" and "URL pattern" before sending the request
      // because we can't change them in the DB
      this.$delete(updateableSettings, 'base_href')
      this.$delete(updateableSettings, 'pattern')

      this.$store.dispatch('setAdvancedSiteSettings',{
          data: updateableSettings
      })
    }
  }
}
</script>

<style lang="css" scoped>
  .tab-card-form{
    min-width: 70%;
  }
  .pretext{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pretext-span{
    width: 100%;
    white-space: normal;
  }
  .text-size-small{
    font-size: 0.8rem;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .disabled-field {
    background-color: rgb(233, 236, 239);
  }
</style>
